import React, { useRef } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import BadgeImage from 'assets/Badge-blue.png'
import { useClickOutSide } from 'hooks'
import { RootState } from '../../store'
import { toggleProfile } from './editProfileSlice'
import ProfileImage from './ProfileImage'
import EditProfileForm from './EditProfileForm'

// todo split props for wrapper and badge
interface StyledProfileProps {
    isShow?: boolean;
    editingSocial?: Social | undefined;
    isSelecting?: boolean;
    top?: number;
    shouldScroll?: boolean;
}
type Social = 'linkedIn' | 'facebook' | 'twitter' | 'instagram';

const S = {
    Wrapper: styled.div<StyledProfileProps>`
        position: absolute;
        top: ${({ top, isShow }) => (isShow ? top : 0)}px;
        left: 0;
        width: 100%;
        height: 100vh;
        overflow: ${({ shouldScroll }) => (shouldScroll ? 'scroll' : 'hidden')};
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.4);
        transition: 0.4s;
        transform: translateY(${({ isShow }) => (isShow ? '0%' : '-100%')});
    `,
    Badge: styled.div<StyledProfileProps>`
        position: relative;
        width: 450px;
        height: 900px;
        margin: auto;
        margin-bottom: 100px;
        background: url(${BadgeImage}) no-repeat center;
        background-size: contain;
        background-position-y: -200px;
    `,
    Form: styled(Form)`
        position: absolute;
        bottom: 205px;
        left: 50%;
        width: 355px;
        height: 480px;
        padding: 15px 20px;
        transform: translateX(-50%);
    `,
    Logo: styled.img`
        height: 70px;
        width: 100%;
        object-fit: contain;
    `,
    FormWrapper: styled.div`
        position: relative;
        width: 100%;
        padding-top: 40px;
        display: flex;
        justify-content: space-between;
    `,
}

const ProfileBadge = ({ callback }: { callback?: () => void }) => {
    const profile = useSelector((state: RootState) => state.auth.user)
    const { isShow } = useSelector((state: RootState) => state.editProfile)
    const formRef = useRef<HTMLDivElement>()
    const dispatch = useDispatch()
    useClickOutSide(formRef, () => isShow && dispatch(toggleProfile()))
    const top = window.scrollY
    const shouldScroll = window.innerHeight < 650

    return (
        <S.Wrapper isShow={isShow} top={top} shouldScroll={shouldScroll}>
            <S.Badge>
                <S.Form ref={formRef}>
                    {profile
                        && (
                            <S.FormWrapper>
                                <ProfileImage profileImage={profile.mugshot} userId={profile.id} />
                                <EditProfileForm profile={profile} callback={callback} />
                            </S.FormWrapper>
                        )}
                </S.Form>
            </S.Badge>
        </S.Wrapper>
    )
}

export default ProfileBadge
